// src/api/auth.api.js
import api from "./axios";

/**
 * Login de usuario
 * @param {string} username
 * @param {string} password
 * @returns {Promise<Object>} objeto con access_token y user
 */
export const loginUser = async (username, password) => {
  const form = new URLSearchParams();
  form.append("username", username);
  form.append("password", password);

  try {
    const { data } = await api.post("/auth/login", form, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return data; // { access_token, token_type, user }
  } catch (error) {
    // Puedes personalizar los errores
    if (error.response) {
      throw new Error(error.response.data.detail || "Error en login");
    } else {
      throw new Error("Error de conexión con el servidor");
    }
  }
};

/**
 * Crear usuario nuevo (pendiente de backend)
 * @param {string} username
 * @param {string} password
 * @param {string} email
 * @returns {Promise<Object>}
 */
export const createUser = async (username, password, email) => {
  try {
    const { data } = await api.post("/users/", {
      username,
      password,
      email,
    });
    return data; // retornar el usuario creado
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.detail || "Error al crear usuario");
    } else {
      throw new Error("Error de conexión con el servidor");
    }
  }
};
